import { CallTreatment } from "./call_treatments";
import { TextTreatment } from "../text_treatments/text_treatments";
import { ChatTreatment } from "../chat_treatments/chat_treatments";

const treatmentTypes = new Map([['TREATMENT', CallTreatment], ['SMS', TextTreatment], ['CHAT', ChatTreatment]])

export class CreateTreatment extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML =
      `
      <style>
        #phone_call_svg, #comment_sms_svg, #web_chat_svg {
          background-size: 30px 30px;
          width:30px;
          height:30px;
          display:inline-block;
        }

        #phone_call_svg {
          background-image: url(/assets/admin/phone_call.svg);
        }

        #comment_sms_svg {
          background-image: url(/assets/admin/comment_sms.svg);
        }

        #web_chat_svg {
          background-image: url(/assets/admin/web_chat.svg);
        }

        create-treatment .templates-btn:hover {
          background-color: #E7F0FE;  
        }

        create-treatment .templates-btn {
          cursor: pointer;
        }
      </style>
      <div class="row create_treatment_container">
        <div class="col-md-8 col-sm-12 col-md-offset-2">
          <h3><span id="treatment_back" class="close_create_treatment"></span> Create Treatment</h3> 

          <div class="row">
            <div class="col-sm-12">
              <p class="welcome-message">Which treatment would you like to build? <a>Learn more</a></p>
            </div>
          </div>
          <div id="treatment_types">
            <div class="col-md-4 col-sm-12">
                <div id="call_treatment_btn" class="templates-btn" data-treatment_type="TREATMENT">
                  <p>Calls</p><span id="phone_call_svg"></span>
                </div>
              </div>

              <!--
              <div class="col-md-4 col-sm-12">
                <div id="text_treatment_btn" class="templates-btn" data-treatment_type="SMS">
                  <p>Messaging</p><span id="comment_sms_svg"></span>
                </div>
              </div>
              -->
              <div class="col-md-4 col-sm-12">
                <div id="chat_treatment_btn" class="templates-btn" data-treatment_type="CHAT">
                  <p>Web Chat</p><span id="web_chat_svg"></span>
                </div>
              </div>
          </div>
        </div>
      </div>
      `;

    this.querySelectorAll('.templates-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        this.createTreatment(e.target.closest('.templates-btn').dataset.treatment_type);
      }.bind(this))
    })

    this.querySelector('#treatment_back').addEventListener('click', function() {
      this.hide();
    }.bind(this))
  }

  createTreatment(type) {
    this.querySelector('.create_treatment_container').classList.add('hidden');
    let treatment = new (treatmentTypes.get(type))(this.show.bind(this));
    this.appendChild(treatment)
  }

  show() {
    this.querySelector('.create_treatment_container').classList.remove('hidden')
  }

  loadTreatment(id, type) {
    this.querySelector('.create_treatment_container').classList.add('hidden');
    let treatment = new (treatmentTypes.get(type))(this.show.bind(this));
    treatment.loadCallTreatment(id);
    this.appendChild(treatment)
  }

  hide() {
    $("#call_treatment_path").hide();
    $("#call_treatments_list").show();
  }
}

customElements.define('create-treatment', CreateTreatment)